(() => {
  $('#loadMore').on('click', function(e) {
    e.preventDefault();
    //init
    const that = $(this);
    const page = $(this).data('page');
    const newPage = page + 1;
    const ajaxurl = my_ajax_object.ajaxurl;
    const numberPost = $(this).data('numberpost');
    const postType = $(this).data('posttype');
    const text = $(this).data('textnodata');
    const cat = $(this).data('catid');
    const data = {
      numberPost: numberPost,
      postType: postType,
      page: page,
      action: 'ajax_script_load_more'
    };
    //ajax call
    $.ajax({
      url: ajaxurl,
      type: 'post',
      data: data,
      error: function(response) {
        console.log(response);
      },
      success: function(response) {
        //check
        if (response == 0) {
          $('#ajax-primary').append(
            '<div id="no-more" class="text-center width__100"><h3>' +
              text +
              '</h3></div>'
          );
          $('#loadMore').hide();
        } else {
          if (response == 0) {
            $('#ajax-primary').append(
              '<div id="no-more" class="text-center width__100"><h3>' +
                text +
                '</h3></div>'
            );
            $('#loadMore').hide();
          } else {
            that.data('page', newPage);
            $('#ajax-primary').append(response);
          }
          console.log(response);
        }
      }
    });
  });
})();
